/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import { host } from './config';

import { IonicVue } from '@ionic/vue';
import './registerServiceWorker';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

defineCustomElements(window);

import axios from 'axios'
import VueAxios from 'vue-axios'
// import { setupCache } from 'axios-cache-adapter'
// import localforage from 'localforage'
// import 'localforage-memoryStorageDriver'


/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';
// import 'primevue/resources/themes/lara-light-teal/theme.css'
// import 'primevue/resources/themes/fluent-light/theme.css'
import 'primevue/resources/themes/saga-blue/theme.css'
import PrimeVue from 'primevue/config';
import Loading from './Loading';

/* Theme variables */
import './theme/variables.css';

let activePostRequests = 0;
let globalLoading: any = null;
let isPresenting = false;

async function dismissLoading() {
  if (isPresenting) {
    setTimeout(dismissLoading, 50);
    return;
  }
  if (globalLoading) {
    try {
      await globalLoading.dismiss();
    } catch (e) {
      console.error(e);
    }
    globalLoading = null;
  }

  // Clean up any stray loading indicators from the DOM if no POST requests are active
  if (activePostRequests <= 0) {
    const loaders = document.querySelectorAll('ion-loading');
    for (let i = 0; i < loaders.length; i++) {
      try {
        await (loaders[i] as any).dismiss();
      } catch (e) {
        try {
          loaders[i].remove();
        } catch (err) { }
      }
    }
  }
}

async function showLoading() {
  if (globalLoading || isPresenting) return;
  isPresenting = true;
  try {
    globalLoading = await Loading.presentLoading('Please Wait');
  } catch (e) {
    console.error(e);
  } finally {
    isPresenting = false;
  }
  if (activePostRequests === 0) {
    dismissLoading();
  }
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (window.localStorage.username == null || window.localStorage.password == null) {
      next({
        path: '/login',
      })
    } else {
      next()
    }
  } else {
    if (window.localStorage.rememberMe == 1 && window.localStorage.username != null && window.localStorage.password != null) {
      next({
        path: '/home',
      })
    }
    next() // make sure to always call next()!
  }
})
const app = createApp(App)
  .use(IonicVue)
  .use(PrimeVue)
  .use(router);
// const host = "https://jahaji-admin.test/";
// const host="http://192.168.50.117:8080/";
// const host="https://dev.jahaji.app/";
// const host = "https://stage.admin.jahajibd.com/";
// const host = "https://appconnect.jahajibd.com/"; // now managed in src/config.js
app.config.globalProperties.$host = host;
axios.defaults.baseURL = host + 'api/inhouse_app/';
const version = '10.0.0';
axios.interceptors.request.use(async function (config) {
  if (config.method == 'post' && !(config as any).skipLoading) {
    if (config.data) {
      if (config.data instanceof FormData) {
        config.data.set('appVersion', String(version));
      } else {
        config.data.appVersion = version;
      }
    }
    (config as any)._showSpinner = true;
    activePostRequests++;
    showLoading();
  } else if (config.method == 'post') {
    if (config.data) {
      if (config.data instanceof FormData) {
        config.data.set('appVersion', String(version));
      } else {
        config.data.appVersion = version;
      }
    }
  }
  return config;
});
axios.interceptors.response.use(response => {
  if (response.config && (response.config as any)._showSpinner) {
    activePostRequests--;
    if (activePostRequests <= 0) {
      activePostRequests = 0;
      dismissLoading();
    }
  }
  return response;
},
  error => {
    if (error.config && (error.config as any)._showSpinner) {
      activePostRequests--;
    }
    if (activePostRequests <= 0) {
      activePostRequests = 0;
      dismissLoading();
    }
    const data = error.response ? error.response.data : {};
    if (error.response && error.response.status == 500) {
      Loading.presentResponseAlert('Error 500', 'Server Error');
    } else if (typeof data.message != 'undefined') {
      Loading.presentResponseAlert('Failed', data.message);
    } else if (typeof data.errors != 'undefined') {
      Loading.presentResponseAlert('Failed', data.errors.join('<br>'));
    }
    return Promise.reject(error);
  });
// const forageStore = localforage.createInstance({
//   // List of drivers used
//   driver: [
//     localforage.INDEXEDDB,
//     localforage.LOCALSTORAGE,
//   ],
//   // Prefix all storage keys to prevent conflicts
//   name: 'my-cache'
// });
// const cache = setupCache({
//   // maxAge: 1 * 24 * 60 * 60 * 1000,
//   maxAge: 60 * 1000,
//   store: forageStore
// });
// axios.defaults.adapter=cache.adapter;
app.use(VueAxios, axios);
// app.axios.defaults.adapter=cache.adapter;
router.isReady().then(() => {
  app.mount('#app');
});